<template>
    <section class="admin-content" id="contact-search">
        <Navbar />
        <main class="admin-main">
            <div class="bg-dark m-b-30">
                <div class="container">
                    <div class="row p-b-60 p-t-60">
                        <div class="col-md-6 text-center mx-auto text-white p-b-30">
                            <h3 class="h4 text-white">Claims Report Page</h3>
                        </div>
                    </div>
                </div>
            </div>
            <section class="">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="card m-b-30 bg-info">
                                <div class="card-body text-dark">
                                    <div class="pb-2">
                                        <div class="avatar avatar-lg">
                                            <div class="avatar-title bg-soft-info rounded-circle">
                                                <i class="mdi mdi-file-document-outline"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="h4">Claims</p>
                                        <h1 class="fw-400">
                                            {{ lastProviderClaimsCount | numeral(0, 0) }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="card m-b-30 bg-default">
                                <div class="card-body text-dark">
                                    <div class="pb-2">
                                        <div class="avatar avatar-lg">
                                            <div class="avatar-title bg-soft-info rounded-circle">
                                                <i class="fe fe-credit-card"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="h4">Amount Requested</p>
                                        <h1 class="fw-400">
                                            <i class="mdi mdi-currency-ngn"></i>{{ providers[providers.length
                                            -1].total_cost | numeral(0, 0) }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="card m-b-30 bg-dark">
                                <div class="card-body text-white">
                                    <div class="pb-2">
                                        <div class="avatar avatar-lg">
                                            <div class="avatar-title bg-soft-info rounded-circle">
                                                <i class="fe fe-database"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="h4">Amount Approved</p>
                                        <h1 class="fw-400">
                                            <i class="mdi mdi-currency-ngn"></i>{{ providers[providers.length
                                            -1].total_verified_price | numeral(0, 0) }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 text-sm">
                            *Data Presented are from {{ from }} to {{ to }}
                        </div>

                        <div class="col-md-12">
                            <div class="card m-b-30">
                                <div class="card-body">
                                    <ClaimsDate />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="card" v-show="filterparams">
                            <div class="card-header">
                                <p class="text-center h4">Filter Parameter</p>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label> Select Sector </label>
                                        <select class="form-control" v-model="sector">
                                            <option :value="sector" v-for="sector in sectors" :key="sector">
                                                {{ sector }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="form-group col-md-6"
                                        v-if="user.type == 'shis' || user.type == 'employee'">
                                        <label> Select Facility </label>

                                        <v-select v-model="provider_id" label="agency_name" :options="providers"
                                            @change="getClaims('json')" />
                                        <button @click="getProviders" class="btn btn-outline-info btn-sm my-2">
                                            All
                                        </button>
                                        <span class="my-2 ml-3">
                                            {{ providers.length }} providers</span>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label> Select Status </label>
                                        <select class="form-control" v-model="claim_status">
                                            <option value="">All</option>
                                            <option value="approved">Approved</option>
                                            <option value="vetted">Vetted</option>
                                            <option value="verified">Verified</option>
                                            <option value="pending">Pending</option>
                                            <option value="rejected">Rejected</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label for="inputCity"><i class="fe fe-calendar"></i> Start Date
                                        </label>
                                        <input type="date" class="form-control" v-model="from" />
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label for="inputCity"><i class="fe fe-calendar"></i> End Date
                                        </label>
                                        <input type="date" class="form-control" v-model="to" />
                                    </div>

                                    <div class="col-md-12 filter-action-buttons">
                                        <button class="btn btn-outline-success" @click="getStats">
                                            <i class="fe fe-bar-chart-2"></i> Get Statistics
                                        </button>

                                        <button class="btn btn-outline-warning" @click="getDiagnosesStats">
                                            <i class="fe fe-thermometer"></i> Export Diagnoses
                                        </button>

                                        <button class="btn btn-outline-info" @click="getClaims('csv')">
                                            <i class="fe fe-download"></i> Export Claims
                                        </button>


                                        <button class="btn btn-dark">
                                            <download-excel :data="providers" :fields="provider_fields" type="xls"
                                                :escapeCsv="false" name="Provider_Claims_Statistics.xls">
                                                <i class="fe fe-file-text"></i>

                                                Export Provider Statistics
                                            </download-excel>
                                        </button>
                                        <button class="btn btn-outline-dark" @click="clearField">
                                            <i class="fe fe-x-circle"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />

                    <div class="card row list">
                        <div class="card-header">

                            <div class="table-responsive">
                                <table class="table align-td-middle table-card">
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            <th>Health Facility</th>
                                            <th>Total Claims</th>
                                            <th>Amount Requested</th>
                                            <th>Amount Vetted</th>
                                            <th>Amount Approved</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(provider, index) in providers" v-bind:key="provider.id">
                                            <td>{{ getRowNumber(index) }}</td>
                                            <td>
                                                {{
                                                provider.agency_name
                                                }}

                                            </td>
                                            <td>
                                                {{ provider.claims_count }}
                                            </td>

                                            <td>
                                                <i class="mdi mdi-currency-ngn"></i> {{ provider.total_cost | numeral(0,
                                                0) }}
                                            </td>
                                            <td>
                                                <i class="mdi mdi-currency-ngn"></i>
                                                {{ provider.total_vetted_price | numeral(0, 0) }}
                                            </td>
                                            <td>
                                                <i class="mdi mdi-currency-ngn"></i>
                                                {{ provider.total_verified_price | numeral(0, 0) }}

                                            </td>


                                        </tr>


                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="vld-parent">
                    <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage">
                    </loading>
                </div>
            </section>
        </main>
    </section>
</template>

<script>
    import Navbar from "@/views/Navbar.vue";
    import ClaimsDate from "@/views/shis/components/ClaimsbyDate.vue";
    // Import component
    import Loading from "vue-loading-overlay";
    // Import stylesheet
    import "vue-loading-overlay/dist/vue-loading.css";
    // Init plugin

    import SectorsJson from "@/json/sectors.json";
    import moment from "moment";
    moment().format();

    export default {
        components: {
            Navbar,
            ClaimsDate,
            Loading,
        },
        data() {
            return {
                user: null,
                filterparams: true,
                isLoading: false,
                fullPage: true,
                from: moment()
                    .subtract(1, "month")
                    .startOf("month")
                    .format("YYYY-MM-DD"),
                to: moment()
                    .subtract(1, "month")
                    .endOf("month")
                    .format("YYYY-MM-DD"),
                providers: [
                    {
                        claims_count: 0,
                        total_cost: 0,
                        total_vetted_price: 0,
                        total_verified_price: 0,
                    }
                ],
                stats: "",
                tpas: "",
                claim_status: "",
                org_id: "",
                provider_id: "",
                sector: "",
                sectors: SectorsJson,
                provider_fields: {
                    "Provider Name": "agency_name",
                    "Program ": "sector",
                    "Total  Claims": "claims_count",
                    "Request  Amount": "total_cost",
                    "Vetted  Amount": "total_vetted_price",
                    "Verified  Amount": "total_verified_price",
                },

                json_meta: [
                    [
                        {
                            key: "charset",
                            value: "utf-8",
                        },
                    ],
                ],
            };
        },
        beforeMount() {
            this.user = JSON.parse(localStorage.getItem("user"));
        },
        computed: {
            totalRequestedCost() {
                if (this.claims.data) {
                    return this.claims.data.reduce((sum, item) => {
                        return sum + item.requested_total_cost;
                    }, 0);
                } else {
                    return 0;
                }
            },
            totalApprovedCost() {
                if (this.claims.data) {
                    return this.claims.data.reduce((sum, item) => {
                        return sum + item.approved_total_cost;
                    }, 0);
                } else {
                    return 0;
                }
            },
            lastProviderClaimsCount() {
                if (!Array.isArray(this.providers) || this.providers.length === 0) {
                    return 0;
                }

                const lastProvider = this.providers[this.providers.length - 1] || {};
                return Number(lastProvider.claims_count) || 0;
            },
        },
        methods: {
            getClaims(format = "json") {
                this.user = JSON.parse(localStorage.getItem("user"));
                this.isLoading = true;
                this.axios
                    .get(`/api/v1/auth/claims/95930`, {
                        params: {
                            format: format,
                            per_page: 50000,
                            claim_status: this.claim_status,
                            claim_unique_id: this.claim_unique_id,
                            authorization_code: this.authorization_code,
                            id_card_number: this.id_card_number,
                            provider_id:
                                this.user.type == "provider_employee"
                                    ? this.user.institutional_id
                                    : this.provider_id.id,
                            org_id: this.org_id,
                            from: this.from,
                            to: this.to,
                            sector: this.sector,
                        },
                    })
                    .then((response) => {

                        if (format === "csv") {
                            const blob = new Blob([response.data], {
                                type: "text/csv;charset=utf-8;",
                            });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.setAttribute(
                                "download",
                                `claims_${new Date().toISOString().slice(0, 10)}.csv`
                            );
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);

                            this.$toasted.success("CSV downloaded successfully", {
                                position: "top-center",
                                duration: 3000,
                            });

                            this.isLoading = false;
                            return;
                        }

                        if (this.providers == "") {
                            this.providers = response.data.providers;
                        }
                        this.claims = response.data;
                        console.log(response);
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.isLoading = false;
                    });
            },
            getRowNumber(index) {
                return index + 1;
            },
            getProviders() {
                this.axios
                    .get(`/api/v1/auth/providerAgency/95930`)
                    .then((response) => {
                        this.providers = response.data.data;
                        console.log(response);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            getStats() {
                this.isLoading = true;
                this.axios
                    .post(`/api/v1/auth/claims/statistics`, {
                        agency_id: 95930,
                        sector: this.sector,
                        from: this.from,
                        to: this.to,
                    })
                    .then((response) => {

                        let filteredData = response.data.data
                            .filter((item) => item.total_cost > 0)
                            .map((item) => ({
                                ...item,
                                sector: this.sector || "All",
                            }));

                        this.providers = filteredData;

                        this.isLoading = false;
                        this.$toasted.success("Queried Successfully!", {
                            position: "top-left",
                            duration: 5000,
                        });
                        console.log(response);
                    })
                    .catch((error) => {
                        console.error(error);
                        this.isLoading = false;
                    });
            },


            getDiagnosesStats() {
                this.isLoading = true;
                this.axios
                    .post(`/api/v1/auth/claims/statistics/diagnoses`, {
                        format: 'csv',
                        agency_id: 95930,
                        sector: this.sector,
                        from: this.from,
                        to: this.to,
                    }, {
                        responseType: "blob",
                    })
                    .then((response) => {

                        const blob = new Blob([response.data], {
                            type: "text/csv;charset=utf-8;",
                        });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute(
                            "download",
                            `diagnoses_statistics_${new Date().toISOString().slice(0, 10)}.csv`
                        );
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);

                        this.isLoading = false;
                        this.$toasted.success("Diagnoses CSV downloaded successfully", {
                            position: "top-left",
                            duration: 5000,
                        });
                        console.log(response);
                    })
                    .catch((error) => {
                        console.error(error);
                        this.isLoading = false;
                    });
            },


            clearField() {
                this.claim_status = "";
                this.claim_unique_id = "";
                this.authorization_code = "";
                this.id_card_number = "";
                this.provider_id = "";
                this.org_id = "";

                this.sector = "";
                this.providers = "";
            },
        },
        created() {
            this.getStats();
        },
    };
</script>
<style scoped>
    .spacer-side {
        margin-left: 3px;
        margin-right: 3px;
    }

    .filter-action-buttons {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5rem;
    }

    @media (min-width: 992px) {
        .filter-action-buttons .btn {
            flex: 1 1 0;
        }
    }
</style>
